import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import AppImage from '../AppImage';
import Button from './Button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Remove Financial Projections from navigation - users access only through calculator
  const navigationItems = [
    {
      name: 'RV Park Calculator',
      path: '/rv-park-calculator',
      icon: 'Calculator'
    }
  ];

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border shadow-sm">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Logo */}
        <a href={import.meta.env.VITE_COMPANY_URL || "https://www.hookhub.co/"} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg overflow-hidden">
            <AppImage 
              src="/assets/images/Screenshot_2025-09-14_at_8.29.20_AM-1757809815817.png" 
              alt="Hookhub Logo" 
              className="w-full h-full object-contain"
            />
          </div>
          <div className="flex flex-col">
            <span className="font-heading font-bold text-lg text-foreground leading-tight">RV Park Income Calculator
            </span>
            <span className="font-heading font-medium text-sm text-muted-foreground leading-tight">Hookhub
            </span>
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-1">
          {navigationItems?.map((item) =>
          <Link
            key={item?.path}
            to={item?.path}
            className={`flex items-center space-x-2 px-4 py-2 rounded-md font-body font-medium text-sm transition-all duration-200 ${
            isActivePath(item?.path) ?
            'bg-primary text-primary-foreground shadow-sm' :
            'text-muted-foreground hover:text-foreground hover:bg-muted'}`
            }>

              <Icon name={item?.icon} size={18} />
              <span>{item?.name}</span>
            </Link>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleMenu}
            className="w-10 h-10">

            <Icon name={isMenuOpen ? 'X' : 'Menu'} size={20} />
          </Button>
        </div>
      </div>
      {/* Mobile Navigation Menu */}
      {isMenuOpen &&
      <div className="md:hidden bg-card border-t border-border animate-slide-down">
          <nav className="px-6 py-4 space-y-2">
            {navigationItems?.map((item) =>
          <Link
            key={item?.path}
            to={item?.path}
            onClick={() => setIsMenuOpen(false)}
            className={`flex items-center space-x-3 px-4 py-3 rounded-md font-body font-medium text-sm transition-all duration-200 ${
            isActivePath(item?.path) ?
            'bg-primary text-primary-foreground shadow-sm' :
            'text-muted-foreground hover:text-foreground hover:bg-muted'}`
            }>

                <Icon name={item?.icon} size={20} />
                <span>{item?.name}</span>
              </Link>
          )}
          </nav>
        </div>
      }
    </header>);

};

export default Header;